import React, { ReactNode, useState, useRef, useCallback, useEffect } from 'react';
import './CustomizeTooltip.css';
import { getValueFromResource } from './timeLiveFunction';
import { useAppDispatch } from '../app/hooks';
import { t } from 'i18next';

interface TooltipProps {
  children: ReactNode;
  content: ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
  style?: React.CSSProperties;
}

const CustomizeTooltip: React.FC<TooltipProps> = ({
  children,
  content,
  position = 'top',
  style,
}) => {
  const dispatch = useAppDispatch();
  const [positionStyle, setPositionStyle] = useState<React.CSSProperties>({});
  const tooltipRef = useRef<HTMLDivElement>(null);
  const parentRef = useRef<HTMLDivElement>(null);
  const contentValue = typeof content === 'string' ? content : '';

  const calculatePosition = useCallback(() => {
    if (!parentRef.current || !tooltipRef.current) return;

    const parentRect = parentRef.current.getBoundingClientRect();
    const tooltipRect = tooltipRef.current.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    let newLeft = parentRect.left + parentRect.width + 40;
    let newTop = parentRect.top + parentRect.height / 2;

    if (newLeft + tooltipRect.width > viewportWidth) {
      newLeft = viewportWidth - tooltipRect.width - 10;
    }

    if (newTop + tooltipRect.height > viewportHeight) {
      newTop = viewportHeight - tooltipRect.height - 10;
    } else if (newTop < 0) {
      newTop = 10;
    }

    setPositionStyle({
      left: newLeft,
      top: newTop,
      // visibility: 'visible',
      opacity: 1,
    });
  }, []);

  useEffect(() => {
    const handleResize = () => {
      calculatePosition();
      setTimeout(calculatePosition, 100);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [calculatePosition]);

  return (
    <div 
      className="tooltip-container" 
      ref={parentRef}
      onMouseEnter={calculatePosition}
      onMouseLeave={() => setPositionStyle({ visibility: 'hidden', opacity: 0 })}
      style={style}
    >
      {children}
      <div
        className={`tooltip-content ${position}`}
        ref={tooltipRef}
        style={{
          ...positionStyle,
          transition: 'opacity 0.2s ease, visibility 0.2s ease',
        }}
        role="tooltip"
        aria-hidden={!positionStyle.visibility}
      >
        {/* {content} */}
        {getValueFromResource(contentValue, dispatch, t)}
      </div>
    </div>
  );
};

export default CustomizeTooltip;